import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-n-50 px-4 text-center">
      <h1 className="text-6xl font-light text-processBlue">404</h1>
      <p className="mt-2 text-steel">That page doesn't exist (or isn't yours to see).</p>
      <Link to="/" className="btn-primary mt-6">
        Back to home
      </Link>
    </div>
  );
}
